import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuthStore } from "@/stores/auth";

export function TopNav() {
  const { t } = useTranslation();
  const email = useAuthStore((s) => s.email);
  const location = useLocation();
  const onAuthPage = location.pathname === "/login" || location.pathname === "/register";

  return (
    <header className="sticky top-0 z-30 border-b border-cream-border/70 bg-cream/90 backdrop-blur">
      <div className="mx-auto flex h-14 w-full max-w-7xl items-center justify-between px-4 sm:px-6">
        <Link
          to="/"
          aria-label={t("nav.aria_home")}
          className="flex items-center gap-2 rounded-md px-1 transition-opacity hover:opacity-80 focus:outline-none focus-visible:ring-2 focus-visible:ring-amber/60"
        >
          <span className="font-serif text-[20px] font-medium tracking-tight text-navy-deep">
            Mavinty
          </span>
          <span className="rounded-full bg-amber/20 px-2 py-0.5 text-[10px] font-medium uppercase tracking-wider text-amber-dark">
            β
          </span>
        </Link>
        {!onAuthPage && email ? (
          <span className="hidden text-[12px] text-taupe sm:block">{email}</span>
        ) : null}
      </div>
    </header>
  );
}
